// extracted by mini-css-extract-plugin
export default {"failed":"Failed_failed__-O0-K","failed__icon":"Failed_failed__icon__WBHqz","failed__message":"Failed_failed__message__X2UQ3","failed__buttons":"Failed_failed__buttons__8gRIo"};